export { area, AreaGeometryOptions } from './area';
export { line, LineGeometryOptions } from './line';
export { point, PointGeometryOptions } from './point';
export { interval, IntervalGeometryOptions } from './interval';
export { polygon, PolygonGeometryOptions } from './polygon';
export { edge, EdgeGeometryOptions } from './edge';
